"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cheerio_utils_1 = require("./cheerio-utils");
/**
 * Remove trailing whitespaces in given element, using given cheerio context.
 * Returns true if the element was empty and removed completely
 */
function removeTrailingWhitespaces($, el) {
    if (el === void 0) { el = cheerio_utils_1.getTopLevelElement($); }
    var hasChildren = el.childNodes && el.childNodes.length > 0;
    var isText = el.type === 'text';
    var isComment = el.type === 'comment';
    var isTextual = cheerio_utils_1.isTextualElement(el);
    if (isComment) {
        // Remove it
        $(el).remove();
        return true;
    }
    else if (isText) {
        if (cheerio_utils_1.isEmptyish(el)) {
            $(el).remove();
            // The element was removed completely
            return true;
        }
        else {
            var trimmed = el.data.trimRight();
            $(el).replaceWith(trimmed);
            // We're done trimming
            return false;
        }
    }
    else if (!isTextual) {
        // Contains content other than text, we stop trimming here
        return false;
    }
    else if (hasChildren) {
        // Textual element with children
        // Trim last child
        var wasEmpty = removeTrailingWhitespaces($, el.lastChild);
        if (wasEmpty) {
            // Continue trimming this element
            return removeTrailingWhitespaces($, el);
        }
        else {
            // The last element was trimmed as much as possible.
            // We stop here
            return false;
        }
    }
    else if (cheerio_utils_1.isRootElement(el)) {
        // Stop here
        return false;
    }
    else {
        // Empty textual element, we can remove it.
        $(el).remove();
        return true;
    }
}
exports.default = removeTrailingWhitespaces;
